export enum FollowupStatusEnum {
    Incomplete = 0,
    Complete = 1
}
